// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

const RecalcUpload = lazy(
  () => import('pages/recalculations/upload/RecalcUpload')
);

const RecalcUploadRoute = (
  <Route path={routeName.recalcUpload}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.PAYOUTREVIEWER_DASHBOARD,
            PrivateRouteConst.MY_TASK,
          ]}
        >
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <RecalcUpload />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RecalcUploadRoute;
